import { Checkbox, Flex } from '@chakra-ui/react';
import './CustomCheckbox.scss';
import parse from 'html-react-parser';
import React from 'react';
import { render } from 'storyblok-rich-text-react-renderer';

export interface CustomCheckboxProps {
  label?: string;
  value?: string;
  onChange?: (value: string | boolean) => void;
  isChecked?: boolean;
  isRequired?: boolean;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  isSingleCheckbox?: boolean;
}

const CustomCheckbox = ({
  label,
  value,
  onChange,
  isRequired = false,
  isChecked = false,
  isDisabled = false,
  isReadOnly = false,
  isSingleCheckbox = false,
}: CustomCheckboxProps) => {
  const handleCheckboxChange = () => {
    if (onChange) {
      onChange(isChecked ? false : (value ?? true));
    }
  };

  const formattedLabel =
    typeof label === 'string' ? parse(label) : render(label);

  return (
    <Flex className={'custom-checkbox-container'}>
      <Checkbox
        className={'custom-checkbox'}
        value={value}
        onChange={handleCheckboxChange}
        isChecked={isChecked}
        isRequired={isRequired}
        isDisabled={isDisabled}
        isReadOnly={isReadOnly}
      />

      {label && (
        <Flex className={'custom-checkbox-label-container'}>
          <span className={'custom-checkbox-label'}>{formattedLabel}</span>

          {isSingleCheckbox && !isRequired && (
            <span className={'custom-form-field-optional-label'}>
              (Optional)
            </span>
          )}
        </Flex>
      )}
    </Flex>
  );
};

export default CustomCheckbox;
